import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';

export class APPaymentUpdatePostDateParametersDto {
    managementCompanyId: number;
    communityId: number;
    paymentId: number;
    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date;
}
